import { useState } from "react"
import Container from "../core/Container"
import Heading from "../core/Heading"
import Paragraph from "../core/Paragraph"
import SectionTag from "../core/SectionTag"
import Button from "../core/Button"
import Image from "../core/Image"




export default function Team() {
    const [expandedEntities, setExpandedEntities] = useState(new Set())

    const medailonky =  [{
        name: "Mgr. Danuše Kubová",
        photo: "user_icon.png",
        short_desc: "Na Základní škole jazyků Karlovy Vary učím němčinu, dějepis a informatiku, zároveň působím jako zástupkyně ředitelky, ICT koordinátorka a koordinátorka ŠVP. Nové technologie mě baví a ráda je zkouším ve výuce – ale vždy tak, aby skutečně pomáhaly a nezatěžovaly učitele ani žáky. Mým cílem je ukázat, že digitalizace může být přirozená, užitečná a hlavně bez stresu.",
        skills: [
            {
                title: "Lektorské zkušenosti",
                items: [
                    "Kurzy a webináře pro NPI (Národní pedagogický institut ČR)",
                    "Digitální kompetence a digitální nástroje: Digitální kompetence v dějepise – 7dílný kurz; Digitální kompetence v cizích jazycích a dějepisu – „Digiplovárna\"; Digitální kompetence v cizích jazycích pro SOŠ – 2dílný kurz",
                    "Umělá inteligence ve vzdělávání: Generativní AI pro učitele; AI ve výuce cizích jazyků – příprava + využití přímo ve výuce; AI pro sborovny – prezenční seminář; AI pro vedení školy",
                    "Konference, akce a workshopy: Konference ELF14 2024; Educa 2025 Liberec – workshop Komiksy, animace a únikové hry ve výuce; Konference Den s didaktikou němčiny 2025; Roadshow Microsoft pro školy; Dny AI (NPI); DigiRoadshow (NPI)",
                    "Další odborné vzdělávání a spolupráce: Krajský ICT metodik v rámci projektu SYPO a NPO (NPI, 2018-2025); Kurz pro ICT koordinátory – lektor, tutor (2023/24); Kurz Word pro asistenty pedagoga; Workshopy k využití ICT ve výuce (MAP, NPI); Autorka webinářů pro NPI"
                ]
            }
            ,{
                title: "Umělá inteligence v praxi (AI pro učitele)",
                items: [
                    "Generování textu, obrázků, videí a jednoduchých aplikací",
                    "Praktické AI nástroje: NotebookLM – práce s texty a dokumenty, příprava na výuku; Mizou; Snorkl; Napkin; Canva AI; Diffit; a další",
                    "Ukázkový AI projekt: tvorba videoklipu v Canvě (propojení textu, hudby s obrázky a videem); chatování s personou; wibecoding v Canva AI – tvorba vlastních aplikací (flashcards, kvízy, pexeso atd.)"
                ]
            },
            {
                title: "Tvorba vizuálního obsahu a výukových materiálů",
                items: [
                    "Canva – prezentace, pracovní listy, videa, AI prvky, šablony",
                    "Genially – interaktivní prezentace, hry, únikovky",
                    "Tvorba komiksu – ve vybraných aplikacích",
                    "Book Creator – tvorba digitálních knih, portfolií a projektů"
                ]
            },
            {
                title: "Interaktivní výuka, spolupráce a řízení hodiny",
                items: [
                    "Padlet – sdílení, nástěnky, brainstorming, projektové učení",
                    "Google Classroom – organizace výuky, zadávání, hodnocení, komunikace",
                    "Nearpod – interaktivní lekce, aktivní zapojení žáků",
                    "Collboard – digitální tabule a spolupráce v reálném čase",
                    "Classroomscreen – řízení hodiny, časovače, nástroje pro třídu"
                ]
            },
            {
                title: "Aktivizace a zpětná vazba (hlasování, otázky, aktivní zapojení)",
                items: [
                    "Mentimeter – hlasování, otázky",
                    "Slido – hlasování, otázky",
                    "Flippity – jednoduché aktivity z tabulek (losování, karty, hry)"
                ]
            },
            {
                title: "Kvízy, procvičování a gamifikace",
                items: [
                    "Kahoot!",
                    "Quizizz",
                    "Blooket",
                    "Quizlet",
                    "Wordwall",
                    "LearningApps – jednoduché interaktivní úkoly",
                    "ClassTools – vybrané aktivity pro výuku",
                    "Baamboozle"
                ]
            },
            {
                title: "Myšlenkové mapy a organizace učení",
                items: [
                    "Coggle",
                    "MindMup",
                    "Orgpad",
                    "Canva",
                    "Coda.io"
                ]
            },
            {
                title: "Praktické nástroje pro výuku (rychlé využití ve škole)",
                items: [
                    "QR kódy – tvorba, využití ve výuce, aktivní stezky",
                    "Liveworksheets – interaktivní pracovní listy",
                    "ChatterPix Kids – mluvící obrázky, kreativní projekty"
                ]
            },
            {
                title: "Projektové a zážitkové učení (hry, únikovky)",
                items: [
                    "Tvorba únikových her – ve vybraných aplikacích (Canva, Genially, Google nástroje aj.)",
                    "Actionbound – interaktivní stezky, venkovní aktivity, projekty"
                ]
            },
            {
                title: "Digitální organizace a online nástroje (pro učitele i vedení)",
                items: [
                    "Google Workspace pro školy – dokumenty, prezentace, formuláře, sdílení, spolupráce",
                    "Microsoft 365 (Word, Excel, Forms) – základy i praktické využití",
                    "Padlet",
                    "Edupage"
                ]
            },
            {
                title: "Webové nástroje a digitální zdroje pro výuku dějepisu a cizích jazyků (důraz na badatelskou výuku)",
                items: [
                    "Ověřené weby a digitální zdroje pro práci s textem, obrázky, mapami, časovými osami a audio/video materiály",
                    "Práce s informacemi a zdroji (primární prameny, digitální archivy, ověřování informací)",
                    "Aktivizační metody – rychlé online aktivity do hodiny (5–10 min), skupinová práce, sdílení",
                    "Tvorba digitálních výukových materiálů (interaktivní pracovní listy, kvízy, prezentace)",
                    "Praktické ukázky z praxe + sdílení tipů a inspirace"
                ]
            },
            {
                title: "Rozvoj digitálních kompetencí u žáků (napříč předměty) – aktivní zapojení žáků ve výuce",
                items: [
                    "Digitální kompetence v praxi – tvoření, spolupráce, prezentace a reflexe",
                    "Aktivní role žáků – žáci jako tvůrci (projekty, výstupy, digitální produkty)",
                    "Bezpečné a zodpovědné používání technologií (digitální stopa, práce se zdroji, autorská práva)",
                    "Práce s informacemi – vyhledávání, ověřování, kritické myšlení (výborné i pro dějepis)",
                    "Ukázky konkrétních aktivit pro různé předměty (obecně, v cizích jazycích i v dějepisu)"
                ]
            }
        ]
    },
    {
        name: "Bc. Martin Vlnas",
        photo: "user_icon.png",
        short_desc: "Jsem absolventem bakalářského studia Aplikované informatiky se zaměřením na softwarové inženýrství. V rámci profesního života vytvářím webové stánky (od návrhu UI/UX až po samotnou realizaci), programuji aplikace a informační systémy.",
        skills: [
            {
                title: "Programování v jazyce Python",
                items: [
                    "Úvod v prostředí Google Colab",
                    "Manipulace s daty a jejich vizualizace pomocí knihoven Pandas a Matplotlib",
                ]
            },
        ]
    }
    ]

    const handleToggleExpand = (entityName) => {
        setExpandedEntities(prev => {
            const newSet = new Set(prev)
            if (newSet.has(entityName)) {
                newSet.delete(entityName)
            } else {
                newSet.add(entityName)
            }
            return newSet
        })
    }

    const renderEntity = ({entity}) => {
        const isExpanded = expandedEntities.has(entity.name)
        
        return (

            <Container 
                bgColor="white" 
                radius="xl" 
                shadow={true}
                className="border-2 border-gray-200 p-6 rounded-2xl flex flex-col h-full hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 hover:border-main"
            >
                
                <Container bgColor="transparent" className="flex justify-center mb-4 items-center">
                    <Heading variant="entity_team">{entity.name}</Heading>
                </Container>

                <Container bgColor="transparent" className="flex justify-center mb-6 mt-2 items-center">
                    <Container bgColor="transparent" className="relative">
                        <Container bgColor="main" className="absolute inset-0 opacity-10 rounded-full blur-xl"></Container>
                        <Image
                        alt={`${entity.name} profilový obrázek`}
                        width={150}
                        src={`./img/${entity.photo}`}
                        className="relative rounded-full border-4 border-main shadow-md"
                        >
                        </Image>
                    </Container>
                </Container>

                <Container bgColor="transparent" className="flex-grow flex flex-col">
                    <Paragraph variant="p" className="text-gray-600 leading-relaxed mb-4">
                        {entity.short_desc}
                    </Paragraph>

                    {isExpanded && entity.skills && entity.skills.length > 0 && (
                        <Container bgColor="transparent" className="mt-4 mb-4 overflow-hidden animate-fadeIn">
                            <Container bgColor="gray-50" radius="lg" className="bg-gradient-to-br from-gray-50 to-white p-5 border border-gray-200 shadow-inner">
                                <ul className="space-y-5">
                                    {entity.skills.map((skill, index) => (
                                        <li key={index} className="mb-4 last:mb-0">
                                            <Container bgColor="transparent" className="flex items-start">
                                                <Container bgColor="main" radius="full" className="flex-shrink-0 w-2 h-2 mt-2 mr-3"></Container>
                                                <Container bgColor="transparent" className="flex-1">
                                                    <Heading variant="h4" className="text-base font-semibold text-gray-800 mb-2 leading-tight">
                                                        {skill.title}
                                                    </Heading>
                                                    {skill.items && (
                                                        <ul className="space-y-2 mt-2">
                                                            {skill.items.map((item, itemIndex) => (
                                                                <li key={itemIndex} className="text-sm text-gray-700 leading-relaxed pl-4 relative before:content-['•'] before:absolute before:left-0 before:text-main before:font-bold">
                                                                    {item}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </Container>
                                            </Container>
                                            {index < entity.skills.length - 1 && (
                                                <Container bgColor="transparent" className="mt-4 border-t border-gray-200"></Container>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            </Container>
                        </Container>
                    )}
                </Container>

                <Container bgColor="transparent" className="flex justify-end items-center mt-auto pt-4 border-t border-gray-200">
                    <Button 
                        onClick={() => handleToggleExpand(entity.name)}
                        className="transition-all duration-200 hover:scale-105"
                    >
                        {isExpanded ? "Skrýt detaily 👆🏼" : "Zobrazit více 👇🏼"}
                    </Button>
                </Container>

            </Container>

        )
    }
    

    return(
        <Container bgColor="transparent" className="w-full py-16 md:py-24">
            <Container bgColor="transparent" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
                {/* Heading Section */}
                <SectionTag>Náš tým</SectionTag>
                <Container bgColor="transparent" className="flex flex-col gap-8">
                    {medailonky.map((en, index) => (
                        <Container key={index} className="w-full md:flex-1 h-full">
                            {renderEntity({entity: en})}
                        </Container>
                    ))}
                </Container>
            </Container>
        </Container>
    )
}